module.exports = __webpack_public_path__ + "img/dl_xx@2x.e5f94eb8.png";